module.exports = __webpack_public_path__ + "img/hic-cardiovascular-diseases-male.31fc68dd.png";